import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios';
import { AcceptNegotiationValidationSchema } from '../schemas/acceptNegotiation.schema';

interface UseAcceptNegotiationProps {
  negotiationId?: string
  onSuccess: (response: AxiosResponse) => void
  onError: (error: ErrorResponse) => void
}

export const useAcceptNegotiation = ({
  negotiationId,
  onSuccess,
  onError,
}: UseAcceptNegotiationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['acceptNegotiation', negotiationId],
    mutationFn: (formAcceptNegotiation: AcceptNegotiationValidationSchema) => {
      const payload = {
        due_at: formAcceptNegotiation.due_at,
      }

      return privateAxios.put(`/client/negotiations/${negotiationId}/accept`, payload);
    },
    onSuccess,
    onError,
  })
}
